import { useAccessibility } from "@/hooks/useAccessibility";

const A11yBootstrap = () => {
  useAccessibility();
  return null;
};

export default A11yBootstrap;
